import { ArrowRight } from 'lucide-react';
import { TEST_IDS } from '../../constants/testIds';

/**
 * Auth gate — shown when no session/token is available.
 * Minimal, centered branding card on a dark background.
 */
export default function AuthGate() {
  return (
    <div
      data-testid={TEST_IDS.AUTH_GATE_SCREEN}
      className="dark min-h-screen flex items-center justify-center p-6"
      style={{ backgroundColor: '#0C0D10' }}
    >
      {/* Subtle radial glow */}
      <div className="absolute inset-0 auth-radial pointer-events-none" />

      <div className="relative max-w-[420px] w-full text-center space-y-10 anim-fade-up">
        {/* Logo mark */}
        <div className="flex justify-center">
          <img
            src="/botview-logo.png"
            alt="BotView Logo"
            className="w-24 h-24 object-contain"
            draggable={false}
          />
        </div>

        {/* Title */}
        <div className="space-y-2">
          <h1
            data-testid={TEST_IDS.AUTH_GATE_TITLE}
            className="text-4xl sm:text-5xl font-bold tracking-tight text-white font-heading"
          >
            BotView
          </h1>
          <p
            data-testid={TEST_IDS.AUTH_GATE_TAGLINE}
            className="text-base sm:text-lg font-semibold font-heading"
            style={{
              background: 'linear-gradient(180deg, #FFC233 0%, #FF6B1A 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Interview Smarter. Get Hired Faster.
          </p>
        </div>

        {/* Info card */}
        <div className="rounded-xl border border-[#272B36] bg-[#14161B] p-6 text-left space-y-4">
          <p className="text-[#9BA1B0] text-sm leading-relaxed font-body">
            This app must be opened from your{' '}
            <span className="text-white font-medium">PlaceValue dashboard</span>.
            Head back to your college portal and launch BotView from there.
          </p>
          <a
            data-testid={TEST_IDS.AUTH_GATE_CTA}
            href="https://placevalue.in"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg
                       text-sm font-semibold font-heading btn-cta"
          >
            Go to PlaceValue
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <p className="text-[11px] text-[#4B5063] font-body">
          AI-powered mock interviews for college students
        </p>
      </div>
    </div>
  );
}
